import { ExpandableDefaultSubmodelDisplay } from 'components/basics/ExpandableNestedContentWrapper';
import { Submodel } from 'api/v3/aas_core_meta/types';
import { CarbonFootprintVisualizations } from './CarbonFootprintVisualizations';

type CarbonFootprintDetailProps = {
    readonly submodel: Submodel;
};

export function CarbonFootprintDetail(props: CarbonFootprintDetailProps) {
    return (
        <>
            <CarbonFootprintVisualizations submodel={props.submodel} />
            <ExpandableDefaultSubmodelDisplay submodel={props.submodel} />
        </>
    );
}
